import axios from 'axios'
import Qs from 'qs'
import store from '@/store'
import router from '@/router'
import Vue from 'vue'
import { Loading, Message } from 'element-ui' // 引用element-ui的加载和消息提示组件
import { Toast } from 'vant' // 引用element-ui的加载和消息提示组件
import { isPC } from "@/utils/browser";

const isPCPort = isPC();

const $axios = axios.create({
  // 设置超时时间
  timeout: 10000,
  // 基础url，会在请求url中自动添加前置链接
  baseURL: ''
})
Vue.prototype.$http = axios // 并发请求
// 在全局请求和响应拦截器中添加请求状态
let loading = null
let toast = null;

// 请求拦截器
$axios.interceptors.request.use(
  config => {
    if (config.url.startsWith('/api/bi/basic') || config.url.startsWith('/api/bi/data_statistics')) {
      config.url = process.env.VUE_APP_STATISTICS_BASIC_API + config.url;
    }
    else if (config.url.startsWith('/api/auth')) {
      config.url = process.env.VUE_APP_AUTH_BASE_API + config.url
    }
    else if (config.url.startsWith('/api/bi')) {
      config.url = process.env.VUE_APP_BI_BASE_API + config.url
    }
    else {
      config.url = process.env.VUE_APP_BASE_API + config.url
    }

    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return Qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }

    if (isPCPort) {
      loading = Loading.service({ text: '拼命加载中' })
    } else {
      toast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
    }

    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截器
$axios.interceptors.response.use(
  response => {
    console.log(123, response)
    if (loading) {
      loading.close()
    }
    if (toast) {
      toast.clear(); // 关闭加载中的弹窗
    }
    const code = response.status;
    if ((code >= 200 && code < 300) || code === 304) {
      if(response.data.code == 401 || response.data.code == 403){
        store.dispatch('user/loginOut')
      }
      // 如果是blob类型的响应
      if (response.headers['content-type'] === 'application/octet-stream;charset=utf-8' || response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'  ) {
        // 这里处理blob类型的响应，例如下载文件
        return response;
      }
      // 这里根据接口规则修改
      if (response.data.code != 2000) {
        // return Promise.reject(response.data)
        if(response.data.code == 1){
          return Promise.resolve(response.data)
        } else {
          return Promise.reject(response.data)
        }
      } else {
        return Promise.resolve(response.data)
      }
    } else {
      if(code == 401 || code == 403){
        store.dispatch('user/loginOut')
      }
      return Promise.reject(response.data)
    }
  },
  error => {
    if (loading) {
      loading.close()
    }
    if (toast) {
      toast.clear(); // 关闭加载中的弹窗
    }
    console.log(error)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (isPCPort) {
            Message.error('请重新登录')
          } else {
            Toast.fail('请重新登录');
          }
          // 返回401 清除token信息并跳转到登陆页面
          store.commit('user/DEL_TOKEN')
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
          break
        case 403:
          if (isPCPort) {
            Message.error('请重新登录')
          } else {
            Toast.fail('请重新登录');
          }
          // 返回401 清除token信息并跳转到登陆页面
          store.commit('user/DEL_TOKEN')
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
          break
        case 404:
          if (isPCPort) {
            Message.error('网络请求不存在')
          } else {
            Toast.fail('网络请求不存在');
          }

          break
        default:
          if (isPCPort) {
            Message.error(error.response.data.msg)
          } else {

            Toast.fail(error.response.data.msg)
          }

      }
    } else {
      // 请求超时或者网络有问题
      if (error.message.includes('timeout')) {
        if (isPCPort) {
          Message.error('请求超时！请检查网络')
        } else {
          Toast.fail('请求超时！请检查网络')
        }

      } else {
        if (isPCPort) {
          Message.error('请求失败，请检查网络')
        } else {
          Toast.fail('请求失败，请检查网络')
        }

      }
    }
    return Promise.reject(error)
  }
)

export default {
  // 支持同时将参数放在 URL 查询字符串和请求体中的 post 函数
  post(url, data, params, responseType) {
    const axiosConfig = {
      method: 'post',
      url,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    };
    if (params && responseType) {
      // 将参数放在 URL 的 query 中
      axiosConfig.params = params;
      axiosConfig.responseType = 'blob'
    } else {
      // 如果没有 params，则将参数放在请求体中
      axiosConfig.data = data;
    }
    return $axios(axiosConfig);
  },
  patch(url, data) {
    return $axios({
      method: 'patch',
      url,
      data,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    })
  },
  put(url, data) {
    return $axios({
      method: 'put',
      url,
      data,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      }
    })
  },
  get(url, params, responseType) {
    if (params && responseType || responseType) {
      const axiosConfig = {
        method: 'get',
        url,
        params
      };
      // 将参数放在 URL 的 query   return $axios(axiosConfig);
      axiosConfig.responseType = 'blob'
      return $axios(axiosConfig);
    }
    return $axios({
      method: 'get',
      url,
      params
    })
  },
  delete(url, params) {
    return $axios({
      method: 'delete',
      url,
      params
    })
  },
  files(url, formData) {
    return $axios({
      method: 'post',
      url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
